import { LogOutSquareIcon } from '../../assets/icons/common';
import { setExitExamModal } from '../../store/exam/slice';
import { useDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function ExitExam() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const exit = () => {
        navigate('/workspace');
        dispatch(setExitExamModal(false));
    };

    return (
        <Modal
            size='sm'
            title='Exit exam'
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setExitExamModal(false))}
        >
            <span className={styles.title}>
                Are you sure you want to exit exam?
            </span>
            <p className={styles.description}>
                If you exit the exam, you will lose your<br />
                opportunity to be evaluated for this job!
            </p>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setExitExamModal(false))}
                />
                <Button
                    type='Error'
                    text='Exit'
                    onClick={exit}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
